export default "__VITE_ASSET__CINC0nrm__"